import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { getValueChanges, RemoteConfig } from '@angular/fire/remote-config';
import { environment } from '../../../../environments/environment.prod';
import { AboutUsComponent } from '../../components/about-us/about-us.component.mjs';
import { BannerComponent } from '../../components/banner/banner.component.mjs';
import { BlogComponent } from '../../components/blog/blog.component.mjs';
import { ContactInfoComponent } from '../../components/contact-info/contact-info.component.mjs';
import { FrequentlyComponent } from '../../components/frequently/frequently.component.mjs';
import { InstallationQuestionsComponent } from '../../components/installation-questions/installation-questions.component.mjs';
import { PlansPricingComponent } from '../../components/plans-pricing/plans-pricing.component.mjs';
import { ServicesSectionComponent } from '../../components/services-section/services-section.component.mjs';
import { SubscribeComponent } from '../../components/subscribe/subscribe.component.mjs';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    BannerComponent,
    PlansPricingComponent,
    ServicesSectionComponent,
    InstallationQuestionsComponent,
    AboutUsComponent,
    ContactInfoComponent,
    FrequentlyComponent,
    SubscribeComponent,
    BlogComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, AfterViewInit {
    private remoteConfig = inject(RemoteConfig);
      title = 'Cladded Glass Broadband';
  
    constructor()
    {
    }
  ngAfterViewInit(): void {
    getValueChanges(this.remoteConfig, "test").subscribe((changed: any) => {
      console.log("Value changed to", changed);
    })

    console.log(environment.firebase.projectId);
}
  
    ngOnInit(): void {
    }


}
